type Role = 'logged-out' | 'designer' | 'contest-holder' | 'administrator';

export interface NavigationRole {
    isAdmin: boolean;
    isDesigner: boolean;
}

export function getNavigationRole(user: NavigationRole | null): Role {
    if (!user) {
        return 'logged-out';
    } else if (user.isAdmin) {
        return 'contest-holder';
    } else if (user.isDesigner) {
        return 'designer';
    } else {
        return 'contest-holder';
    }
}
